import { Link } from "react-router-dom";
import { Row, Col, Card, CardBody } from "reactstrap";

import { LibraryCategory } from "../../interfaces/models/LibraryCategory";
import { MULTI_LIBRARY } from "../Routes/routingConstants";
import { getImageUrl } from "../../helper/getImageUrl";

interface Props {
  categories: LibraryCategory[];
  
}

const LibraryCategoryComponent = ({ categories }: Props) => {

  return (
    <Row
      style={{  justifyContent: "center", minHeight:'70vh' }}
      className="animated-card"
    >
      {categories.map((it, i) => (
        <Col
          key={"main_category" + i}
          xs={12}
          lg={5}
          xl={4}
          className="w-100 my-3"
        >
          <Link
            to={`${MULTI_LIBRARY}?id=${it._id}`}
          >
            <Card
              key={i}
              className="position-relative notification-cats-card hovering-effect mb-4 mb-xl-0 h-100 overflow-hidden shadow-lg overlay"
              style={{
                //@ts-ignore
                "--backgroundImage": `url(${getImageUrl(it.image_id)})`,
              }}
            >
              <CardBody className="card-background d-flex justify-content-center align-items-center">
                <h5 className="display-4 text-center text-uppercase text-white">
                  {it.description}
                </h5>
              </CardBody>
            </Card>
          </Link>
        </Col>
      ))}
    </Row>

  );

}

export default LibraryCategoryComponent;